<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-7">
            <template v-if="getRoleId === '1'">
              <a v-if="getRoleId != '33'" @click="openPage('/notification/add')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a>
            </template>
          </div>
          <div class="col-sm-5 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
<!--          <template slot="branch_pic_sales" slot-scope="data">-->
          <template v-slot:cell(branch_pic_sales)="data">
            <template v-for="itemLoop in itemSales">
              <template v-if="data.item.branch_pic_sales_id === itemLoop.id">
                {{itemLoop.fullname}}
              </template>
            </template>
          </template>


          <template v-slot:cell(message)="data">
            <span class="message" v-html="data.item.message"></span>
          </template>
<!--          <template slot="branch_pic_customer_service" slot-scope="data">-->
          <template v-slot:cell(branch_pic_customer_service)="data">
            <template v-for="itemLoop in itemCS">
              <template v-if="data.item.branch_pic_customer_service_id === itemLoop.id">
                {{itemLoop.name}}
              </template>
            </template>
          </template>
<!--          <template slot="actions" slot-scope="data">-->
          <template v-slot:cell(actions)="data">
            <template v-if="getRoleId == '1'">
              <!-- <b-button size="sm" @click="editBranch('/branch/edit?id=' + data.item.id)" class="btn-table warning mr-1">
              <i class="far fa-edit"></i> Edit
              </b-button> -->
              <b-button v-if="getRoleId != '33'" size="sm" v-on:click="deleteBranch(data.item.id)" class="btn-table danger">
                <i class="fas fa-times"></i> Delete
              </b-button>
            </template>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<style>
  .message img {
    width: 50%;
  }
</style>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'

export default {
  name: 'notification',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'subject',
          label: 'Subject',
          sortable: true
        },
        {
          key: 'message',
          label: 'Message',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'Created At',
          formatter: (value, key, item) => {
            return  item.created_at ? moment(item.created_at).format('DD/MM/YYYY hh:mm') : '-'
          },
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false
        }
      ],
      items: [],
      itemSales: [],
      itemCS: [],
      getRoleId: Auth.Session.get().paradigm_role,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editBranch (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    deleteBranch(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        console.log()
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('crm/v1/notification/'.concat(event)).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('crm/v1/notification?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      // axios.get('crm/v1/sales').then(response => {
      //   this.itemSales = response.data.data.rows
      // }).catch(error => {
      //   console.log('error', error)
      // })
      // axios.get('crm/v1/customer_service').then(response => {
      //   this.itemCS = response.data.data.rows
      // }).catch(error => {
      //   console.log('error', error)
      // })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
